import React from 'react'
import { twMerge } from 'tailwind-merge'

import Label from './Label'

type BadgeProps = React.ComponentPropsWithoutRef<'div'> & {
    value?: number
}

const Badge = ({ value, className, ...props }: BadgeProps) => {
    const isDot = typeof value === 'undefined'
    const displayValue = value && value > 99 ? '99+' : value

    return (
        <div
            role="presentation"
            className={twMerge(
                'flex items-center justify-center',
                isDot ? 'size-3' : 'h-6 min-w-6 px-1.5',
                'bg-danger-400 rounded-full border-2 border-white text-white',
                className
            )}
            {...props}
        >
            {!isDot && <Label size="xs">{displayValue}</Label>}
        </div>
    )
}

export default Badge
